import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        status: '',
        token: localStorage.getItem('token') || '',
        email: localStorage.getItem('email') || '',
        role: localStorage.getItem('role') || '',
        partner: localStorage.getItem('partner') || '',
        partnerName: localStorage.getItem('partnerName') || '',
        userId: localStorage.getItem('userId') || '',
    },
    mutations: {
        auth_request(state) {
            state.status = 'loading';
        },
        auth_success(state, data) {
            state.status = 'success';
            state.token = data.token;
            state.role = data.role;
            state.email = data.email;
            state.partner = data.partner;
            state.partnerName = data.partnerName;
        },
        auth_error(state) {
            state.status = 'error';
        },
        logout(state) {
            state.status = '';
            state.token = '';
        },
    },
    actions: {
        login({commit}, user) {
            return new Promise((resolve, reject) => {
                commit('auth_request');
                axios({url: this.getters.partnerApiUrl + '/login', data: user, method: 'POST'})
                    .then((resp: any) => {
                        const {token} = resp.data;
                        const userData = resp.data.user;
                        localStorage.setItem('token', token);
                        localStorage.setItem('role', userData.role);
                        localStorage.setItem('email', userData.email);
                        localStorage.setItem('partner', userData.partner);
                        localStorage.setItem('partnerName', userData.partnerName);
                        localStorage.setItem('userId', userData.userId);
                        axios.defaults.headers.common.Authorization = 'Bearer ' + token;
                        commit('auth_success', {
                            token,
                            role: userData.role,
                            email: userData.email,
                            partner: userData.partner,
                            partnerName: userData.partnerName
                        });
                        resolve(resp);
                    })
                    .catch((err: any) => {
                        commit('auth_error');
                        localStorage.removeItem('token');
                        reject(err);
                    });
            });
        },
        logout({commit}) {
            return new Promise((resolve, reject) => {
                commit('logout');
                localStorage.removeItem('token');
                localStorage.removeItem('email');
                localStorage.removeItem('role');
                localStorage.removeItem('partner');
                localStorage.removeItem('partnerName');
                localStorage.removeItem('userId');
                delete axios.defaults.headers.common.Authorization;
                resolve('');
            });
        },
    },
    getters: {
        isLoggedIn: (state) => !!state.token,
        token: (state) => state.token,
        authStatus: (state) => state.status,
        user: (state) => state.email,
        role: (state) => state.role,
        partner: (state) => state.partner,
        userId: (state) => state.userId,
        partnerName: (state) => state.partnerName,
        partnerApiUrl: () => process.env.VUE_APP_PARTNER_API,
        publicPath: () => process.env.BASE_URL,
    },
});
